import { IHexGridData } from 'js/bubbleCore/types';
import { getGridValue } from 'js/bubbleCore/utils/getGridValue';

export function isSpaceFree<T>(grid: IHexGridData<T>, col: number, row: number): boolean {
  return getGridValue(grid, col, row) === null;
}